var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.5C1.5 4.125 1.82812 3.75 2.25 3.75H21.75C22.125 3.75 22.5 4.125 22.5 4.5C22.5 4.92188 22.125 5.25 21.75 5.25H2.25C1.82812 5.25 1.5 4.92188 1.5 4.5ZM1.5 12C1.5 11.625 1.82812 11.25 2.25 11.25H21.75C22.125 11.25 22.5 11.625 22.5 12C22.5 12.4219 22.125 12.75 21.75 12.75H2.25C1.82812 12.75 1.5 12.4219 1.5 12ZM22.5 19.5C22.5 19.9219 22.125 20.25 21.75 20.25H2.25C1.82812 20.25 1.5 19.9219 1.5 19.5C1.5 19.125 1.82812 18.75 2.25 18.75H21.75C22.125 18.75 22.5 19.125 22.5 19.5Z",
    fill: "#232639"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBars);
export default __webpack_public_path__ + "static/media/menu-bars.4fa9a87de8b932a331a2d6f7329c2cf4.svg";
export { ForwardRef as ReactComponent };